import { Component, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { LoaderService } from 'app/services/loader/Loader.service';


@Component({
    selector: 'app-spinner',
    templateUrl: './spinner.component.html',
    styleUrls: ['./spinner.component.scss'],
    encapsulation: ViewEncapsulation.ShadowDom,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SpinnerComponent {
  constructor(public loader: LoaderService) { }
}